import React from "react";
import BgImg from "../assests/backgroundImage2.avif";
import { motion } from "framer-motion";
import portfolioImg1 from "../assests/portfolio1.png";
import portfolioImg2 from "../assests/portfolio2.avif";
import { useMediaQuery, useTheme } from "@mui/material";

const Portfolio = () => {

    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(380));


    const styles = {
        container: {
            backgroundImage: `url(${BgImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            color: 'white',
            textAlign: 'center',
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        content: {
            padding: '20px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        innerBox: {
            width: isSmall ? '100%' : isMobile ? '95%' : isBig ? '90%' : '80%',
            padding: isMobile ? '5px' : '20px',
            borderRadius: '15px',
            boxSizing: 'border-box',
            marginTop: 20,
            color: '#000'
        },
        blackBox: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',

        },
        leftBox: {
            width: isMobile ? '100%' : '45%',
            textAlign: 'left',
            padding: isMobile ? '5px' : '20px',
            boxSizing: 'border-box',
            borderRadius: '15px'
        },
        rightBox: {
            width: isMobile ? '100%' : '45%',
            padding: isMobile ? '5px' : '20px',
            boxSizing: 'border-box',
            borderRadius: '15px',
            textAlign: 'left',
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={{ width: isMobile ? '95%' : isBig ? '80%' : '60%', marginTop: 50 }}>
                    <motion.div
                        initial={{ opacity: 0, y: 50, scale: 0.6 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                        viewport={{ amount: 0.5 }}
                        style={{ fontSize: isMobile ? '20px' : '45px', fontWeight: 700, color: '#000' }}
                    >
                        And Yes, Profitable Scaling Can Be Done (With Proven Systems)
                    </motion.div>
                </div>

                <motion.div
                    style={{ marginTop: '20px', color: '#000', width: isMobile ? '95%' : isBig ? '70%' : '40%', lineHeight: '1.5' }}
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                >
                    Our partners brands have grown by 30-40% MoM past the revenue ceiling & added an extra $50k/Month profitably in less than 90 days
                </motion.div>


                <motion.div
                    initial={{ opacity: 0, x: isMobile ? -100 : -500, scale: 0.6 }}
                    whileInView={{ opacity: 1, x: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: isMobile ? 0.1 : 0.5, once: true }}
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            {
                                isMobile
                                    ?
                                    <img src={portfolioImg1} style={{ width: '100%' }} ></img>
                                    :
                                    <>
                                        <h2>Your Long-Term Growth Partner</h2>

                                        <div style={{ lineHeight: 1.5 }}>
                                            Over $16M+ in Attributed Revenue for eCommerce  brands on Meta & Google.  We're not your average ads agency, we're the growth marketing geeks behind the curtain with proven holistic strategies, seeing the entire ecommerce game as interconnected. We're not just ad-runners we're offer architects as well, crafting irresistible deals that not only turn heads but keep your unit economics doing the happy dance. We believe that 20% is what happens inside an ad account & 80% is what happens outside of it.
                                        </div>
                                    </>
                            }

                        </div>

                        <div style={styles.rightBox}>
                            {
                                isMobile ?
                                    <>
                                        <h3>Your Long-Term Growth Partner</h3>

                                        <div style={{ lineHeight: 1.5 }}>
                                            Over $16M+ in Attributed Revenue for eCommerce  brands on Meta & Google.  We're not your average ads agency, we're the growth marketing geeks behind the curtain with proven holistic strategies, seeing the entire ecommerce game as interconnected. We're not just ad-runners we're offer architects as well, crafting irresistible deals that not only turn heads but keep your unit economics doing the happy dance. We believe that 20% is what happens inside an ad account & 80% is what happens outside of it.
                                        </div>
                                    </>
                                    :
                                    <img src={portfolioImg1} style={{ width: '100%' }} ></img>
                            }
                        </div>
                    </div>
                </motion.div>


                <motion.div
                    initial={{ opacity: 0, x: isMobile ? 100 : 500, scale: 0.6 }}
                    whileInView={{ opacity: 1, x: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: isMobile ? 0.1 : 0.5, once: true }}
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            <img src={portfolioImg2} style={{ width: '100%' }} ></img>
                        </div>

                        <div style={{ ...styles.rightBox, textAlign: 'left', lineHeight: 1.5 }}>
                            {
                                isMobile ?
                                    <h3>Beat The Ad Fatigue With Psychology Ads</h3>
                                    :
                                    <h2>Beat The Ad Fatigue With Psychology Ads</h2>
                            }

                            <div >
                                What’s the most common issue brands encounter at scale? Its Creative Fatigue that stops them. Through aligning psychological concepts, research-backed strategies & conversion-focused frameworks, we craft angles, headlines, hooks & concepts tailored to your brand. Consider it like thumbstopping ads that deeply connect with your audience based on their desires, behaviours & passions.Thus, less becomes  more & you see clear uptrends in CPAs coming down drastically, you see more scale with same adspend & better creative hit/win rate.
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div >
    );
};


export default Portfolio;
